import { GitBranchIcon } from "lucide-react";
import { observer } from "mobx-react-lite";

import { compositionRefDisplayName } from "../utils";

import type { ISchemaParameter } from "./schema-parameter-store";

interface Props {
  parameter: ISchemaParameter;
}

const CompositionPropertyPanel = observer(({ parameter }: Props) => {
  const keyword = parameter.compositionKeyword ?? "oneOf";
  const branches = parameter.compositionBranches;

  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/80 p-3 dark:border-slate-700 dark:bg-slate-900/40">
      <div className="mb-2 flex flex-wrap items-center gap-2 text-sm font-medium text-slate-800 dark:text-slate-200">
        <GitBranchIcon className="h-4 w-4 shrink-0 text-slate-500" aria-hidden />
        <span>
          Union type (
          <code className="rounded bg-slate-200 px-1 py-0.5 font-mono text-xs dark:bg-slate-800">
            {keyword}
          </code>
          )
        </span>
        <span className="rounded-full border border-slate-300 bg-white px-2 py-0.5 text-xs font-normal text-slate-600 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-400">
          JSON-defined · read-only
        </span>
      </div>
      <ul className="space-y-1.5">
        {branches.map((branch, index) => {
          const key = branch.$ref ?? `inline-${index}`;
          const label = branch.$ref ? compositionRefDisplayName(branch.$ref) : "Inline schema";
          return (
            <li
              key={key}
              className="flex items-center gap-2 rounded border border-slate-200 bg-white px-2.5 py-1.5 text-sm dark:border-slate-600 dark:bg-slate-950"
            >
              <span className="font-medium text-slate-900 dark:text-slate-100">{label}</span>
              {branch.$ref ? (
                <code className="ml-auto truncate font-mono text-xs text-slate-500 dark:text-slate-400">
                  {branch.$ref}
                </code>
              ) : (
                <span className="ml-auto text-xs text-slate-500 dark:text-slate-400">
                  Edit in JSON editor
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
});

export default CompositionPropertyPanel;
